import { Box, CircularProgress, Alert } from "@mui/material";

interface QueryStateProps {
  isLoading: boolean;
  isError: boolean;
  serviceName?: string;
}

export const QueryState = ({
  isLoading,
  isError,
  serviceName = "data",
}: QueryStateProps) => {

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box py={4}>
        <Alert severity="error">
          Error loading {serviceName}.
        </Alert>
      </Box>
    );
  }

  return null;
};
